import { GlobalStyleDefaults } from "manifest-components/src/Styles/globals";
import User from "manifest-core/classes/employerDashboard/user";

export const AppState = {
  theme: {
    ...GlobalStyleDefaults,
  },
  showFullScreenLoader: false,
  headerClass: "",
  userFetched: false,
  fetchingUser: false,
  fetchingUserDetails: false,
  user: {} as User,
  emailVerified: false,
  emailAddressChanged: false,
  phoneNumberChanged: false,
  countriesListFetched: false,
  passwordChanged: false,
  showHamburgerMenu: false,
  showTopBarIcons: { showArrow: true, showHamburger: true },
  userDetailsFetched: false,
  navigationBlockedReason: "",
  statesList: [] as string[],
  statesListFetched: false,
};
